import {z} from 'zod';

import {
  advertisingAdapterErrorCodeSchema,
  advertisingJobStatusSchema,
  advertisingProgressSchema,
  advertisingPublicationStatusSchema,
} from './AdvertisingCommonSchemas';

export const advertisingJobStatusResponseSchema = z.object({
  jobId: z.string().uuid(),
  status: advertisingJobStatusSchema,
  publicationStatus: advertisingPublicationStatusSchema.optional(),
  publicationId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  linkToAd: z.string().nullable(),
  errorCode: advertisingAdapterErrorCodeSchema.nullable(),
  errorMessage: z.string().nullable(),
  progress: advertisingProgressSchema.nullable(),
});

export type AdvertisingJobStatusResponse = z.infer<typeof advertisingJobStatusResponseSchema>;
